import { useEffect } from 'react';

import { notifyExternalExtensionSettingsChanged } from 'src/data/infinity';
import { captureMessage } from 'src/lib/sentry';
import { useCurrentUser } from 'src/store/user';

/**
 * Notify "external" Extension that relevant settings were changed in the Platform
 */
export const useNotifyAboutSettingsChanged = () => {
  const currentUser = useCurrentUser();

  useEffect(() => {
    if (!currentUser?.settings) {
      return;
    }

    notifyExternalExtensionSettingsChanged(currentUser?.settings).catch((error) => {
      captureMessage('Error while notifying Infinity about "changed settings"', {
        level: 'warning',
        extra: {
          error: error.toString(),
          source: 'useNotifyAboutSettingsChanged',
        },
      });
    });
  }, [currentUser?.settings]);
};
